import { ConfigurationTreeviewEnum } from "./configuration-treeview.enum";

export class ConfigurationTreeview {
  niveauUn: ConfigurationTreeviewEnum;
  niveauDeux: ConfigurationTreeviewEnum;
  niveauTrois: ConfigurationTreeviewEnum
}
